export default __webpack_public_path__ + "static/media/breathe.e8449bb0.png";